import type { JSX } from "react";
import { ChevronIcon } from "vega-icons";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { ThemedButton, type ThemedButtonProps } from "../ThemedButton";

/**
 * A themed button with the input variant, which is a fake dropdown/input button.
 *
 * @example <ThemedButton variant="input">
 *
 **/
export const DropdownButton = ({
  open,
  as,
  ...props
}: ThemedButtonProps & { open: boolean; as?: keyof JSX.IntrinsicElements }) => (
  <ThemedButton
    aria-expanded={open}
    as={as}
    className={cnTwMerge(
      "group flex justify-between px-2 w-full",
      props.className,
    )}
    fullWidth
    icon={
      <ChevronIcon
        className={cnTwMerge(
          "h-4 w-4 shrink-0 text-text/secondary group-hover:text-text/interactive defaultTransition",
          open && "rotate-180",
        )}
      />
    }
    iconPosition="right"
    variant="input"
    {...props}
  />
);
